module.exports = {"fb_pixel_id":"351922425536005"}


//////////////////
// WEBPACK FOOTER
// ./src/config/constants.json
// module id = 644
// module chunks = 0